import PrescriptionInterface, {
  PrescriptionItemInterface,
  DoctorInterface,
  PatientInterface,
} from '../../interfaces/prescription';
import { PermissionsInterface } from '../../interfaces/drugstore';
import HistoryInterface from '../../interfaces/history';
import ItemsStatusInterface from '../../interfaces/itemsStatus';

export interface PrescriptionError {
  exists: boolean;
  status: number;
}
export interface PrescriptionState {
  readonly error: PrescriptionError;
  readonly loading: boolean;
  readonly prescription: PrescriptionInterface;
  readonly dispensation: {
    errors: string[];
    loading: boolean;
  };
  readonly permissions: PermissionsInterface;
  readonly mustUpdateHistory: boolean;
  readonly history: HistoryInterface[];
  readonly historyLoading: boolean;
  readonly historyError: boolean;
  readonly itemsStatus: ItemsStatusInterface[];
  readonly showFullPrescriptionDownloadButton: boolean;
}

export enum ActionTypes {
  FETCH = 'prescription/FETCH',
  FETCH_SUCCESS = 'prescription/FETCH_SUCCESS',
  FETCH_ERROR = 'prescription/FETCH_ERROR',
  DISPENSE = 'prescription/DISPENSE',
  DISPENSE_SUCCESS = 'prescription/DISPENSE_SUCCESS',
  DISPENSE_ERROR = 'prescription/DISPENSE_ERROR',
  DISPENSE_CANCEL = 'prescription/DISPENSE_CANCEL',
  DISPENSE_CANCEL_SUCCESS = 'prescription/DISPENSE_CANCEL_SUCCESS',
  UPDATE_ITEMS = 'prescription/UPDATE_ITEMS',
  UPDATE_ITEM_QUANTITY = 'prescription/UPDATE_ITEM_QUANTITY',
  SET_UNLOCK_DATA = 'prescription/SET_UNLOCK_DATA',
  FETCH_HISTORY = 'prescription/FETCH_HISTORY',
  FETCH_HISTORY_SUCCESS = 'prescription/FETCH_HISTORY_SUCCESS',
  FETCH_HISTORY_ERROR = 'prescription/FETCH_HISTORY_ERROR',
}

export interface FetchAction {
  type: ActionTypes.FETCH;
}

export interface FetchSuccessAction {
  type: ActionTypes.FETCH_SUCCESS;
  prescription: PrescriptionInterface;
}

export interface FetchErrorAction {
  type: ActionTypes.FETCH_ERROR;
  status: number;
}

export interface DispenseAction {
  type: ActionTypes.DISPENSE;
}

export interface DispenseSuccessAction {
  type: ActionTypes.DISPENSE_SUCCESS;
  prescription: PrescriptionInterface;
}

export interface DispenseErrorAction {
  type: ActionTypes.DISPENSE_ERROR;
  errors: string[];
}

export interface DispenseCancelAction {
  type: ActionTypes.DISPENSE_CANCEL;
}

export interface DispenseCancelSuccessAction {
  type: ActionTypes.DISPENSE_CANCEL_SUCCESS;
  prescription: PrescriptionInterface;
}

export interface UpdateItemsAction {
  type: ActionTypes.UPDATE_ITEMS;
  items: PrescriptionItemInterface[];
}

export interface UpdateItemQuantityAction {
  type: ActionTypes.UPDATE_ITEM_QUANTITY;
  itemId: number;
  quantity: number | 'all';
}

export interface UpdateItemQuantityAction {
  type: ActionTypes.UPDATE_ITEM_QUANTITY;
  itemId: number;
  quantity: number | 'all';
}

export interface SetUnlockDataActionPayload {
  doctor: Partial<DoctorInterface>;
  patient: Partial<PatientInterface>;
}

export interface SetUnlockDataAction {
  type: ActionTypes.SET_UNLOCK_DATA;
  payload: SetUnlockDataActionPayload;
}

export interface FetchHistoryAction {
  type: ActionTypes.FETCH_HISTORY;
}

export interface FetchHistorySuccessAction {
  type: ActionTypes.FETCH_HISTORY_SUCCESS;
  history: HistoryInterface[];
  itemsStatus: ItemsStatusInterface[];
  showFullPrescriptionDownloadButton: boolean;
}

export interface FetchHistoryErrorAction {
  type: ActionTypes.FETCH_HISTORY_ERROR;
}

export interface FetchHistoryAction {
  type: ActionTypes.FETCH_HISTORY;
}

export interface FetchHistorySuccessAction {
  type: ActionTypes.FETCH_HISTORY_SUCCESS;
  history: HistoryInterface[];
  itemsStatus: ItemsStatusInterface[];
  showFullPrescriptionDownloadButton: boolean;
}

export interface FetchHistoryErrorAction {
  type: ActionTypes.FETCH_HISTORY_ERROR;
}

export type Action =
  | FetchAction
  | FetchSuccessAction
  | FetchErrorAction
  | DispenseAction
  | DispenseSuccessAction
  | DispenseErrorAction
  | DispenseCancelAction
  | DispenseCancelSuccessAction
  | UpdateItemsAction
  | UpdateItemQuantityAction
  | SetUnlockDataAction
  | FetchHistoryAction
  | FetchHistorySuccessAction
  | FetchHistoryErrorAction;
